import { render, staticRenderFns } from "./PopupActivationEventDetails.vue?vue&type=template&id=3bfdfcae&scoped=true&"
import script from "./PopupActivationEventDetails.vue?vue&type=script&lang=js&"
export * from "./PopupActivationEventDetails.vue?vue&type=script&lang=js&"
import style0 from "./PopupActivationEventDetails.vue?vue&type=style&index=0&id=3bfdfcae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfdfcae",
  null
  
)

export default component.exports